/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { productColor, textColor, grayScale } from 'components/styles';
import BaseButton, { ButtonProps } from './BaseButton';

/**
 * プライマリボタン
 *
 * @see https://sketch.cloud/s/2b3Pe/a/k9qkrA
 */
const InfoButton: React.FC<ButtonProps> = ({
  text, onClick, disabled, ghost, children, fullwidth = false, minWidth='120px', customStyle = css({})
}) => (
  <BaseButton
    color={{
      baseColor: productColor.editAction,
      textColor: textColor.inversed,
      ghostColor: productColor.editAction,
      ghostTextColor: productColor.editAction,
      hoverColor: disabled ? grayScale.gray20 : productColor.editActionHover,
      focusColor: productColor.editAction,
    }}
    text={text}
    onClick={onClick}
    disabled={disabled}
    ghost={ghost}
    fullwidth={fullwidth}
    minWidth={minWidth}
    customStyle={customStyle}
  >
    {children}
  </BaseButton>
);

export default InfoButton;
